var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap align-items-center"},[_c('div',{staticClass:"mr-auto"},[_c('p',{staticClass:"text-uppercase text-dark font-weight-bold mb-1"},[_vm._v(" Your profit ")]),_c('p',{staticClass:"text-gray-5 mb-0"},[_vm._v(" Average Weekly Profit ")])]),_c('p',{staticClass:"text-success font-weight-bold font-size-24 mb-0"},[_vm._v(" +29,931 ")])])
}]

export { render, staticRenderFns }